/* HODO MIRUKA story interactions. Progressive enhancement; the content is always visible. */
(() => {
  const register = (name, constructor) => {
    if (!customElements.get(name)) customElements.define(name, constructor);
  };

  register('miruka-v2-reveal', class extends HTMLElement {
    connectedCallback() {
      if (window.Shopify?.designMode || window.matchMedia('(prefers-reduced-motion: reduce)').matches || typeof IntersectionObserver === 'undefined') {
        this.classList.add('is-in-view');
        return;
      }
      this._observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          this.classList.add('is-in-view');
          this._observer?.disconnect();
        }
      }, { threshold: 0.16 });
      this._observer.observe(this);
    }
    disconnectedCallback() { this._observer?.disconnect(); }
  });

  register('miruka-v2-night', class extends HTMLElement {
    connectedCallback() {
      this._slider = this.querySelector('input[type="range"]');
      this._onInput = event => this.style.setProperty('--m2-split', `${event.target.value}%`);
      if (this._slider) this.addEventListener('input', this._onInput);
    }
    disconnectedCallback() { if (this._onInput) this.removeEventListener('input', this._onInput); }
  });

})();
